export default function() {
  return { interval: 1800000, pageSize: 20  }
}
